import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MonitorHeart = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.11 12.45 14 10.24l-3.11 6.21c-.16.34-.51.55-.89.55s-.73-.21-.89-.55L7.38 13H2v7h20v-7h-6c-.38 0-.73-.21-.89-.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4H2v7h6c.38 0 .73.21.89.55L10 13.76l3.11-6.21a1 1 0 0 1 1.79 0L16.62 11H22V4z"
  }));
});
MonitorHeart.displayName = 'MonitorHeart';
export var MonitorHeartDimensions = {
  height: 24,
  width: 24
};